import { useCountryCode } from '../../../../hooks/useConfiguration';
import h, { buildFullURL } from '../../../../helpers/common';
import { STORE_NAME } from '@intigral/constant';
import { IPurchaseCCFormProps } from '../../types/iPurchase';

export const PurchaseCCForm: React.FC<IPurchaseCCFormProps> = ({ formRef, selectedPPVEvent }) => {
    const countryCode = useCountryCode();
    const { email, accountId } = h.getStore(STORE_NAME.USER) || {};

    return (
        <form
            ref={formRef}
            action={process.env['NX_PUBLIC_PPV_CC_PAYMENT_URL']}
            name="ppvForm"
            id="ppvForm"
            method="post"
            style={{ display: 'none' }}
        >
            <input type="hidden" name="countryCode" value={countryCode || ''} />
            <input type="hidden" name="operatorCode" value="CC" />
            <input type="hidden" name="email" value={email} />
            <input type="hidden" name="foreignAccountId" value={accountId} />
            <input type="hidden" name="lang" value={h.getLang()} />
            <input
                type="hidden"
                name="payPerViewGuids"
                value={JSON.stringify([{ guid: selectedPPVEvent.subscriptionGuid, eventId: selectedPPVEvent.eventId }])}
            />
            <input type="hidden" name="qitafRefId" value="" />
            <input type="hidden" name="customerIp" value="" />
            <input type="hidden" name="callbackUrl" value={buildFullURL('', { eventId: selectedPPVEvent.eventId })} />
            <input
                type="hidden"
                name="successUrl"
                value={buildFullURL('', { eventId: selectedPPVEvent.eventId, success: true })}
            />
            <input
                type="hidden"
                name="failureUrl"
                value={buildFullURL('', { eventId: selectedPPVEvent.eventId, success: false })}
            />
        </form>
    );
};
